import { chakra } from '@chakra-ui/react'

import { shouldForwardProp } from 'src/utils/should-forward-prop'
import { isChromakeyModeActive } from 'src/utils/env'
import {
    PARAGRAPH_METADATA_DESKTOP_FONT_SIZE_COEFF,
    PARAGRAPH_METADATA_MOBILE_FONT_SIZE_COEFF,
} from 'src/components/TranscriptViewer/ParagraphView/constants'

type SpeakerProps = {
    $color: string
    $isTextEditingAvailable: boolean
}

export const Speaker = chakra<'div', SpeakerProps>('div', {
    baseStyle: (props) => {
        const { $color, $isTextEditingAvailable, theme } = props

        return {
            fontFamily: 'inherit',
            textAlign: isChromakeyModeActive ? 'right' : 'unset',
            fontSize: `${PARAGRAPH_METADATA_DESKTOP_FONT_SIZE_COEFF}em`,
            color: $color,

            ...(!$isTextEditingAvailable && {
                userSelect: 'none',
                pointerEvents: 'none',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }),

            [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
                fontSize: `${PARAGRAPH_METADATA_MOBILE_FONT_SIZE_COEFF}em`,
            },
        }
    },
    shouldForwardProp,
})
